export default "__VITE_ASSET__CLfhRrWD__"